<template>
  <MainLayout page-name="customer-master">
    <PageHeader :title="title">
      <el-row class="header-button">
        <el-col>
          <el-button type="primary" class="register" @click="clickRegister">新規追加</el-button>
        </el-col>
        <el-col>
          <el-button type="primary" class="detail-search" @click="clickDetailSearch">詳細検索</el-button>
        </el-col>
      </el-row>
      <SimpleSearch
        :model="simpleSearchFormModel"
        @search="clickSearch"
      >
        <CustomerCode v-model="simpleSearchFormModel.customer_code" :searchCond="true" :autocomplete-list="customerCodeSet" :initialize="true" />
        <CustomerName v-model="simpleSearchFormModel.customer_name" :searchCond="true" :autocomplete-list="customerNameSet" :initialize="true" />
      </SimpleSearch>
    </PageHeader>
    <Table
      :table-data="tableData"
      :dataFormatter="csvDataFormatter"
      :default-sort="{ prop: 'customer_code', order: 'ascending' }"
      @row-click="clickRow"
      @multiple-delete="deleteRows"
    >
      <template #columns>
        <!-- <CustomerCodeColumn :sortable="true" />
        <CustomerNameColumn :sortable="true" />
        <PrivateIdColumn :sortable="true" prop="private_id_name" />
        <InvoiceAddressColumn :sortable="true" />
        <PostalCodeColumn :sortable="true" />
        <StreetAddressColumn :sortable="true" />
        <PhoneNumberColumn :sortable="true" />
        <MenuColumn @copy="copyRow" :cbdelete="deleteRow" /> -->
        <CustomerCodeColumn />
        <CustomerNameColumn />
        <PrivateIdColumn prop="private_id_name" />
        <InvoiceAddressColumn />
        <PostalCodeColumn />
        <StreetAddressColumn />
        <PhoneNumberColumn />
        <MenuColumn @copy="copyRow" :cbdelete="deleteRow" />
      </template>
    </Table>
    <CustomerMasterRegisterDialog
      :visible.sync="registerDialogVisible"
      :autocomplete-customer-code-set="customerCodeSet"
      :autocomplete-customer-name-set="customerNameSet"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
    <CustomerMasterDetailSearchDialog
      :visible.sync="detailDalogVisible"
      :autocomplete-customer-code-set="customerCodeSet"
      :autocomplete-customer-name-set="customerNameSet"
      @search="detailSearch"
    />
    <CustomerMasterEditDialog
      :visible.sync="editDialogVisible"
      :autocomplete-customer-code-set="customerCodeSet"
      :autocomplete-customer-name-set="customerNameSet"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/templates/MainLayout.vue'
import PageHeader from '@/components/organisms/PageHeader.vue'
import CustomerCode from '@/components/molecules/form/autocomplete/CustomerCode.vue'
import CustomerName from '@/components/molecules/form/autocomplete/CustomerName.vue'
import SimpleSearch from '@/components/organisms/SimpleSearch.vue'
// import Table from '@/components/molecules/table/Table.vue'
import Table from '@/components/molecules/table/TablePaging.vue'
import CustomerCodeColumn from '@/components/molecules/table/CustomerCodeColumn.vue'
import CustomerNameColumn from '@/components/molecules/table/CustomerNameColumn.vue'
import PrivateIdColumn from '@/components/molecules/table/PrivateIdColumn.vue'
import InvoiceAddressColumn from '@/components/molecules/table/InvoiceAddressColumn.vue'
import PostalCodeColumn from '@/components/molecules/table/PostalCodeColumn.vue'
import StreetAddressColumn from '@/components/molecules/table/StreetAddressColumn.vue'
import PhoneNumberColumn from '@/components/molecules/table/PhoneNumberColumn.vue'
import MenuColumn from '@/components/molecules/table/MenuColumn.vue'
import CustomerMasterRegisterDialog from '@/components/pages/master/customerMaster/CustomerMasterRegisterDialog.vue'
import CustomerMasterDetailSearchDialog from '@/components/pages/master/customerMaster/CustomerMasterDetailSearchDialog.vue'
import CustomerMasterEditDialog from '@/components/pages/master/customerMaster/CustomerMasterEditDialog.vue'
import CustomerAutocompleteLoader from '@/mixins/CustomerAutocompleteLoader.vue'

export default {
  components: {
    MainLayout,
    PageHeader,
    CustomerCode,
    CustomerName,
    SimpleSearch,
    Table,
    CustomerCodeColumn,
    CustomerNameColumn,
    PrivateIdColumn,
    InvoiceAddressColumn,
    PostalCodeColumn,
    StreetAddressColumn,
    PhoneNumberColumn,
    MenuColumn,
    CustomerMasterRegisterDialog,
    CustomerMasterDetailSearchDialog,
    CustomerMasterEditDialog
  },
  mixins: [
    CustomerAutocompleteLoader
  ],
  data () {
    return {
      title: '顧客マスタ',
      tableData: [],
      simpleSearchFormModel: {
        customer_code: '',
        customer_name: ''
      },
      currentRow: {},
      importDialogVisible: false,
      registerDialogVisible: false,
      detailDalogVisible: false,
      editDialogVisible: false
    }
  },
  computed: {
  },
  mounted () {
    sessionStorage.removeItem('customerSearchCond')
    this.loadCustomer()
  },
  methods: {
    clickImport () {
      this.importDialogVisible = true
    },
    clickRegister () {
      this.currentRow = {}
      this.registerDialogVisible = true
    },
    clickDetailSearch () {
      this.detailDalogVisible = true
    },
    clickSearch () {
      sessionStorage.setItem('customerSearchCond', JSON.stringify(this.simpleSearchFormModel))
      this.search()
    },
    detailSearch () {
      const searchCond = JSON.parse(sessionStorage.getItem('customerSearchCond'))
      Object.keys(this.simpleSearchFormModel).forEach((x) => { this.$set(this.simpleSearchFormModel, x, searchCond[x]) })
      this.search()
    },
    search () {
      this.$loadingMask.on()
      const searchCond = JSON.parse(sessionStorage.getItem('customerSearchCond'))
      this.$axios
        .get('/search-customer', { params: searchCond })
        .then((res) => {
          this.tableData = res.data.list
          for (var i = 0; i <= this.tableData.length - 1; i += 1) {
            // this.tableData[i].selected = false
            this.$set(this.tableData[i], 'selected', false)
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    refreshSearch () {
      this.search()
      this.margeCustomerCodeSet(this.tableData.map((x) => x.customer_code))
      this.margeCustomerNameSet(this.tableData.map((x) => x.customer_name))
      this.refreshAutocompleteList()
    },
    csvDataFormatter (row) {
      const result = { ...row }
      delete result.updated_on
      result.start_date += ' 00:00:00'
      result.end_date += ' 00:00:00'
      return result
    },
    // clickRow (row, column, event) {
    //   this.currentRow = row
    //   this.editDialogVisible = true
    // },
    clickRow (row, table) {
      this.currentRow = row
      this.editDialogVisible = true
      this.tableData = table
    },
    copyRow (row) {
      this.currentRow = row
      this.registerDialogVisible = true
    },
    deleteRow (row) {
      this.deleteRows([row])
    },
    async deleteRows (rows) {
      if (!(await this.$fcMessage.messageBox(this.title, 'CMN0003W'))) {
        return
      }

      this.$loadingMask.on()
      await this.$axios
        .delete('/customer', { data: rows })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.search()
        })
        .catch((e) => {
          this.$loadingMask.off()
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message, true)
                break
              default:
            }
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 2rem;
  ::v-deep .el-col {
    width: auto;
    margin-left: 2rem;
    .el-button {
      font-size: inherit;
      width: 20rem;
    }
  }
}
.dummy {
  display: none;
}
</style>
<style lang="scss">
  .customer-master .el-table {
    th,
    td {
      &.customer-code {
        width: 9em !important;
      }
    }
  }
</style>
